export const ECOMMERCE_ID = [3,10]
export const ROW = 30000
export const ID_CANCELED = 13
export const TIME_NOTIFICATION_INTERVAL = 2000;
